import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CustomTabPanel = ({ setSelectedPanelStatus, setLoad }) => {
  const [value, setValue] = React.useState(0);
  const statusMapper = {
    0: 'SMTP',
    1: 'Logger',
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setLoad(true);
    setSelectedPanelStatus(statusMapper[newValue]);
  };

  const getTabLabel = (label, index) => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        flexDirection: 'row',
      }}
    >
      <Typography
        sx={{
          fontSize: '0.875rem',
          lineHeight: 1.25,
          fontWeight: 700,
          color: value === index ? '#2065D1' : '#637381',
        }}
      >
        {label}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider', ml: 2 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={getTabLabel('SMTP', 0)} {...a11yProps(0)} />
          <Tab label={getTabLabel('Logger', 1)} {...a11yProps(1)} />
        </Tabs>
      </Box>
    </Box>
  );
};
export default CustomTabPanel;
